import { useTheme } from '@emotion/react';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { tokens } from '../theme';

export default function Headeer(props) {
  const { title, subtitle, onLightBackground, actions } = props;
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const titleGradient = onLightBackground
    ? `linear-gradient(135deg, ${colors.primary[900]} 0%, ${colors.blueAccent[600]} 100%)`
    : `linear-gradient(135deg, ${colors.grey[100]} 0%, ${colors.blueAccent[300]} 100%)`;

  return (
    <Box
      sx={{
        mb: 4,
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'flex-start' },
        justifyContent: 'space-between',
        gap: { xs: 2, sm: 2.5 },
      }}
    >
      <Box
        sx={{
          flex: '1 1 auto',
          minWidth: 0,
          position: 'relative',
          '&::after': {
            content: '""',
            position: 'absolute',
            bottom: -8,
            left: 0,
            width: '80px',
            height: '4px',
            background: `linear-gradient(90deg, ${colors.blueAccent[500]} 0%, ${colors.greenAccent[500]} 100%)`,
            borderRadius: '2px',
          },
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 600,
            background: titleGradient,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            mb: 0.5,
            letterSpacing: '0.5px',
            position: 'relative',
            display: 'inline-block',
          }}
        >
          {title}
        </Typography>

        {subtitle && (
          <Typography
            variant="h5"
            sx={{
              color: onLightBackground ? colors.grey[700] : colors.grey[300],
              fontWeight: 400,
              mt: 0.5,
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              '&::before': {
                content: '""',
                width: '4px',
                height: '4px',
                borderRadius: '50%',
                backgroundColor: colors.greenAccent[400],
                display: 'inline-block',
              },
            }}
          >
            {subtitle}
          </Typography>
        )}
      </Box>

      {actions ? (
        <Box
          sx={{
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: { xs: 'stretch', sm: 'flex-end' },
            alignSelf: { xs: 'stretch', sm: 'flex-start' },
            pt: { xs: 0, sm: 0.5 },
            '& > *': { width: { xs: '100%', sm: 'auto' } },
          }}
        >
          {actions}
        </Box>
      ) : null}
    </Box>
  );
}
